import React from "react";
import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";

function KopfplatteDicke({ dicke = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.thicknessWasherPlate")}</p>}
      indicesValue={<span>V</span>}
      inputValue={<span className="input">{dicke}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default KopfplatteDicke;
